type StoredAuthDetails = {
  user?: {
    userId?: string;
  };
} | null;

export const getStoredAuthDetails = (): StoredAuthDetails => {
  if (typeof window === "undefined") return null;

  try {
    const raw = window.localStorage.getItem("authDetails");
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_error) {
    return null;
  }
};

export const resolveWalletTargetUserId = ({
  overrideUserId,
  contextUserId,
  hydratedUserId,
}: {
  overrideUserId?: string;
  contextUserId?: string;
  hydratedUserId?: string;
}) => {
  return (
    overrideUserId
    || contextUserId
    || hydratedUserId
    || getStoredAuthDetails()?.user?.userId
    || ""
  );
};

export const getWalletPageNumber = (pageNumber?: number) => {
  if (typeof pageNumber !== "number" || Number.isNaN(pageNumber)) {
    return 1;
  }

  return pageNumber + 1;
};
